import React, { Component } from 'react';
import List from '@mui/material/List';
import CartMenuItem from './CartMenuItem';
import ReceiveMethodEnum from '../../enums/ReceiveMethodEnum';
import { Divider, Grid, ListItem, Typography } from '@mui/material';
import { inject, observer } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import CurrencyDisplay from '../common/CurrencyDisplay';

@inject('cartStore', 'menuStore')
@observer
class CartMenuList extends Component {
  render() {
    const { cartStore, menuStore, t } = this.props;
    return (
      <List style={{ padding: '0' }}>
        {cartStore.cartData.menus.map((cartMenu, index) => (
          <CartMenuItem cartMenu={cartMenu} index={index} key={index} />
        ))}
        {cartStore.cartData.receiveMethodCode === ReceiveMethodEnum.DELIVERY && (
          <ListItem divider style={{ padding: '16px' }}>
            <Grid container spacing={2}>
              <Grid item container xs direction="column" spacing={1}>
                <Grid item>
                  <Typography component="span" variant="subtitle1" color="textPrimary" style={{ fontWeight: 'bold' }}>
                    {t('order.label.DeliveryFee')}
                  </Typography>
                </Grid>
              </Grid>

              <Grid item style={{ marginRight: '48px' }}>
                <CurrencyDisplay amount={Number(menuStore.storeData.deliveryFee)} />
              </Grid>
            </Grid>
            <Divider />
          </ListItem>
        )}
      </List>
    );
  }
}

export default withTranslation()(CartMenuList);
